<div class="container container-shadow">
  <h4 class="pt-4">
    Oral Deposition
    <span *ngIf="!loading">
      &nbsp;for {{ oralDeposition.deponent_name }}
      <small>
        requested on {{ oralDeposition.created_at_str }}&nbsp;
        <app-oral-deposition-status [status]="oralDeposition.status"></app-oral-deposition-status>
      </small>
    </span>
  </h4>
  <hr />
  <div *ngIf="loading" class="my-5 py-5 text-center">
    <i class="fas fa-fw fa-spinner fa-5x fa-pulse"></i>
  </div>
  <div *ngIf="!loading">
    <h6 class="pb-3">
      <a [routerLink]="'/matters/' + oralDeposition.matter_id"> {{ oralDeposition.matter_number }} - {{ oralDeposition.matter_name }} </a>
    </h6>
    <div class="row">
      <div class="col-sm-6">
        <table class="table">
          <tbody>
            <tr>
              <td colspan="2">
                <a *ngIf="oralDeposition.status != 'cancelled'" class="text-danger" href="javascript: void(0)" (click)="cancelOralDeposition()"><i class="fas fa-minus-circle"></i>&nbsp;Cancel</a>
                &nbsp;&nbsp;
                <a *ngIf="oralDeposition.status == 'cancelled' || oralDeposition.status == 'scheduled'" href="javascript: void(0)" (click)="rescheduleEvent()"><i class="fas fa-redo-alt"></i>&nbsp;Reschedule</a>
                &nbsp;&nbsp;
                <a *ngIf="oralDeposition.editing_allowed" [routerLink]="'/oral_depositions/' + oralDeposition.id + '/edit'"><i class="fas fa-pencil-alt"></i>&nbsp;Edit</a>
              </td>
            </tr>
            <tr>
              <th scope="row">Deponent</th>
              <td>
                <a [title]="oralDeposition.deponent_notes" [href]="'/contacts/' + oralDeposition.deponent_id" target="_blank">
                  {{ oralDeposition.deponent_name }}
                </a>
                <br *ngIf="oralDeposition.deponent_phone_number" />
                <a appPhoneCallBilling [phoneCallContactName]="oralDeposition.deponent_name || ''" [href]="'tel:' + oralDeposition.deponent_phone_number" title="Call {{ oralDeposition.deponent_phone_number }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ oralDeposition.deponent_phone_number }}</a>
              </td>
            </tr>
            <tr>
              <th scope="row">Deposition Address</th>
              <td>{{ oralDeposition.address_simple }}</td>
            </tr>
            <tr>
              <th scope="row">Schedule By</th>
              <td>{{ oralDeposition.schedule_by_str }}</td>
            </tr>
            <tr>
              <th scope="row">Judge</th>
              <td>
                <a [href]="'/contacts/' + oralDeposition.judge_id" target="_blank">{{ oralDeposition.judge_name }}</a>
              </td>
            </tr>
            <tr>
              <th scope="row">Stenographer</th>
              <td>
                <a [href]="'/contacts/' + oralDeposition.stenographer_id" target="_blank">{{ oralDeposition.stenographer_name }}</a>
              </td>
            </tr>
            <tr>
              <th scope="row">Deposition Fee</th>
              <td>{{ oralDeposition.fee | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
            </tr>
            <tr>
              <th scope="row">Initial Notes</th>
              <td>{{ oralDeposition.notes }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="card">
          <div class="card-header">
            <a href="javascript: void(0)" title="New note" class="float-right" (click)="showNewNote = !showNewNote"><i class="fas fa-plus-circle"></i></a>
            Notes&nbsp;<app-badge badgeType="primary">{{ oralDeposition.matter_history_notes.length }}</app-badge>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" *ngIf="showNewNote">
              <div class="form-group">
                <label>New Note:</label>
                <app-tinymce [initialContent]="newNote" (onEditorKeyup)="newNote = $event"></app-tinymce>
              </div>
              <div class="form-group mt-2">
                <button (click)="saveNote()" [disabled]="savingNote" type="button" class="btn btn-sm btn-primary">
                  {{ savingNote ? 'Saving' : 'Save' }}<span *ngIf="savingNote">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
                </button>
                &nbsp;
                <button type="button" class="btn btn-sm btn-secondary" (click)="showNewNote = false" [disabled]="savingNote">Cancel</button>
              </div>
            </li>
            <li class="list-group-item" *ngFor="let matterHistory of oralDeposition.matter_history_notes">
              <div *ngIf="!matterHistory.editing">
                <small class="text-muted">{{ matterHistory.created_updated_wording }}</small>
                <div [innerHTML]="matterHistory.message"></div>
                <div>
                  <a href="javascript: void(0)" (click)="matterHistory.editing = true" title="Edit Note"><i class="fas fa-edit"></i></a>
                  &nbsp;&nbsp;
                  <a href="javascript: void(0)" class="text-danger" (click)="deleteNote(matterHistory)" title="Delete Note"><i class="fas fa-trash"></i></a>
                  &nbsp;&nbsp;
                  <a href="javascript: void(0)" (click)="emailNote(matterHistory)" title="Email to Attorney"><i class="fas fa-envelope-square"></i></a>
                </div>
              </div>
              <div *ngIf="matterHistory.editing">
                <div class="form-group">
                  <label>Note:</label>
                  <app-tinymce [initialContent]="matterHistory.message" (onEditorKeyup)="matterHistory.message = $event"></app-tinymce>
                </div>
                <div class="form-group mt-2">
                  <button (click)="saveNote(matterHistory.message, matterHistory)" [disabled]="savingNote" type="button" class="btn btn-sm btn-primary">
                    {{ savingNote ? 'Saving' : 'Save' }}<span *ngIf="savingNote">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span>
                  </button>
                  &nbsp;
                  <button type="button" class="btn btn-sm btn-secondary" (click)="matterHistory.editing = false" [disabled]="savingNote">Cancel</button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="card">
          <div class="card-header">
            <a class="float-right" *ngIf="oralDeposition.editing_allowed" [routerLink]="'/oral_depositions/' + oralDeposition.id + '/edit'" title="Edit participants"><i class="fas fa-pencil-alt"></i></a>
            Participants&nbsp;<app-badge badgeType="primary">{{ oralDeposition.participants.length }}</app-badge>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" *ngFor="let participant of oralDeposition.participants">
              <a [href]="'/contacts/' + participant.participant_id" target="_blank">{{ participant.name }}</a>
              <br />
              <div *ngFor="let phoneNumber of participant.phone_numbers"><a appPhoneCallBilling [phoneCallContactName]="participant.name || ''" [href]="'tel:' + phoneNumber" title="Call {{ phoneNumber }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ phoneNumber }}</a></div>
              <div *ngFor="let emailAddress of participant.email_addresses">{{ emailAddress }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row mt-3 pb-3">
      <div class="col">
        <div class="card">
          <div class="card-header">
            <a class="float-right" *ngIf="oralDeposition.editing_allowed" title="Propose new event" href="javascript: void(0)" (click)="showNewEvent = !showNewEvent"><i class="fas fa-calendar-plus"></i></a>
            Proposed Deposition Events&nbsp;<app-badge badgeType="primary">{{ oralDeposition.oral_deposition_events.length }}</app-badge>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item" *ngIf="showNewEvent">
              <div class="form-group">
                <label>New Event:</label>
                <div class="row">
                  <div class="col-md-3">
                    <app-datepicker [date]="newOralDepositionEvent.date" (date_result)="newOralDepositionEvent.date = $event"></app-datepicker>
                  </div>
                  <div class="col-md-4">
                    <app-timepicker [initial_time]="newOralDepositionEvent.start_time" (time_result)="newOralDepositionEvent.start_time = $event"></app-timepicker>
                  </div>
                  <div class="col-md-1 text-center" style="line-height: 38px; vertical-align: middle">to</div>
                  <div class="col-md-4">
                    <app-timepicker [initial_time]="newOralDepositionEvent.end_time" (time_result)="newOralDepositionEvent.end_time = $event"></app-timepicker>
                  </div>
                </div>
              </div>
              <div class="form-group mt-2">
                <button type="button" [disabled]="savingEvent" (click)="saveEvent()" class="btn btn-sm btn-primary">
                  {{ savingEvent ? 'Saving' : 'Save' }}<span *ngIf="savingEvent">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                </button>
                &nbsp;
                <button type="button" [disabled]="savingEvent" class="btn btn-sm btn-secondary" (click)="showNewEvent = false">Cancel</button>
              </div>
            </li>
            <li class="list-group-item" *ngIf="oralDeposition.oral_deposition_events.length > 0">
              <table class="table">
                <thead>
                  <tr>
                    <th *ngIf="oralDeposition.editing_allowed"></th>
                    <th>Event Timing</th>
                    <th>Participant Acceptance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let oral_deposition_event of oralDeposition.oral_deposition_events">
                    <td *ngIf="!oral_deposition_event.editing && oralDeposition.editing_allowed">
                      <a href="javascript: void(0)" (click)="oral_deposition_event.editing = !oral_deposition_event.editing">
                        <i class="fas fa-pencil-alt"></i>
                      </a>
                      <a href="javascript: void(0)" (click)="deleteProposedEvent(oral_deposition_event)" title="Delete Proposed Event" class="text-danger">
                        <i class="fas fa-trash"></i>
                      </a>
                    </td>
                    <td *ngIf="!oral_deposition_event.editing">
                      <strong>{{ oral_deposition_event.date_str }}</strong>
                      <span *ngIf="oralDeposition.status == 'scheduled' && oral_deposition_event.event_id">&nbsp;<app-badge badgeType="success">Scheduled</app-badge></span>
                      <br />
                      {{ oral_deposition_event.start_time_str }} to {{ oral_deposition_event.end_time_str }}&nbsp;&nbsp;{{ oral_deposition_event.distance_of_time_in_words }}
                    </td>
                    <td *ngIf="!oral_deposition_event.editing">
                      <div class="custom-control custom-checkbox" *ngFor="let oralDepositionAccept of oral_deposition_event.oral_deposition_accepts" (click)="acceptanceChanged(oralDepositionAccept, oral_deposition_event.id)">
                        <input [disabled]="!oralDeposition.editing_allowed" [checked]="oralDepositionAccept.accepted_checkbox" type="checkbox" class="custom-control-input" />
                        <label class="custom-control-label">
                          {{ oralDepositionAccept.participant_name }}
                          &nbsp;
                          <i class="fas" [ngClass]="{ 'fa-calendar': !oralDepositionAccept.accepted, 'fa-calendar-check': oralDepositionAccept.accepted, 'text-success': oralDepositionAccept.accepted, 'text-muted': !oralDepositionAccept.accepted }"></i>
                        </label>
                      </div>
                      <div>
                        <button [disabled]="schedulingEvent" (click)="scheduleEvent(oral_deposition_event.id)" type="button" *ngIf="oralDeposition.editing_allowed && oral_deposition_event.all_participants_accepted && oralDeposition.status != 'scheduled'" class="btn btn-block btn-sm btn-success">
                          Schedule
                        </button>
                        <button type="button" *ngIf="!oral_deposition_event.event_id && oralDeposition.status != 'scheduled' && oralDeposition.status != 'cancelled'" (click)="holdEvent(oral_deposition_event)" [disabled]="holdingEvent || cancellingEvent" class="btn btn-primary btn-sm btn-block">
                          {{ oral_deposition_event.holdingEvent ? 'Holding Event' : 'Hold Event' }}<span *ngIf="oral_deposition_event.holdingEvent">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                        </button>
                        <button type="button" *ngIf="oral_deposition_event.event_id && oralDeposition.status != 'scheduled' && oralDeposition.status != 'cancelled'" (click)="cancelEvent(oral_deposition_event)" [disabled]="holdingEvent || cancellingEvent" class="btn btn-warning btn-sm btn-block">
                          {{ oral_deposition_event.cancellingEvent ? 'Cancelling Event' : 'Cancel Event' }}<span *ngIf="oral_deposition_event.cancellingEvent">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                        </button>
                        <div *ngIf="oralDeposition.templates && oralDeposition.templates.length > 0">
                          <strong>Preview</strong>
                          <ul>
                            <li *ngFor="let template of oralDeposition.templates">
                              <a target="_blank" [href]="'/matters/' + oralDeposition.matter_id + '/oral_depositions/' + oralDeposition.id + '/preview_template.pdf?doc_template_id=' + template.id">{{ template.name }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                    <td colspan="3" *ngIf="oral_deposition_event.editing">
                      <div class="form-group">
                        <label>New Event:</label>
                        <div class="row">
                          <div class="col-md-3">
                            <app-datepicker [date]="oral_deposition_event.date" (date_result)="oral_deposition_event.date = $event"></app-datepicker>
                          </div>
                          <div class="col-md-4">
                            <app-timepicker [initial_time]="oral_deposition_event.start_time" (time_result)="oral_deposition_event.start_time = $event"></app-timepicker>
                          </div>
                          <div class="col-md-1 text-center" style="line-height: 38px; vertical-align: middle">to</div>
                          <div class="col-md-4">
                            <app-timepicker [initial_time]="oral_deposition_event.end_time" (time_result)="oral_deposition_event.end_time = $event"></app-timepicker>
                          </div>
                        </div>
                      </div>
                      <div class="form-group mt-2">
                        <button type="button" [disabled]="savingEvent" (click)="saveEvent(oral_deposition_event)" class="btn btn-sm btn-primary">
                          {{ savingEvent ? 'Saving' : 'Save' }}<span *ngIf="savingEvent">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
                        </button>
                        &nbsp;
                        <button type="button" [disabled]="savingEvent" class="btn btn-sm btn-secondary" (click)="oral_deposition_event.editing = false">Cancel</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="my-3 py-3"></div>
